import { render } from "./WebhookFiltersTab.vue?vue&type=template&id=2c4e19ae&scoped=true"
import script from "./WebhookFiltersTab.vue?vue&type=script&lang=js"
export * from "./WebhookFiltersTab.vue?vue&type=script&lang=js"

import "./WebhookFiltersTab.vue?vue&type=style&index=0&id=2c4e19ae&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4e19ae"]])

export default __exports__